import Vue from 'vue';
import VueRouter from 'vue-router';
import Meta from 'vue-meta';

Vue.use(VueRouter);
Vue.use(Meta);

const routes = [
  {
    path: '/extend-trial',
    name: 'ExtendTrial',
    component: () => import(/* webpackChunkName: "ExtendTrial" */'./views/Registration/ExtendTrial.vue'),
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import(/* webpackChunkName: "Success" */'./views/Registration/Success.vue'),
  },
  {
    path: '/troubleshoot',
    name: 'Troubleshoot',
    component: () => import(/* webpackChunkName: "Troubleshoot" */'./views/Registration/Troubleshoot.vue'),
  },
  {
    path: '/500',
    name: 'NotAllowed',
    component: () => import(/* webpackChunkName: "NotAllowed" */'./views/NotAllowed.vue'),
  },
  {
    path: '/*',
    name: 'Deprecated',
    component: () => import(/* webpackChunkName: "Deprecated" */'./views/Deprecated.vue'),
  },
];

/**
 * @note Enabling `history` mode works locally. But doesn't work on Amplify environments.
 * Even with the redirect setup per the router docs. So don't use `mode: 'history',`
 * unless you have some time to fuck around with getting it working on Ampilfy. In the end
 * it doesn't really matter b/c the URLs are all autogenerated and directed to via the app in
 * the popup window. Which can't modify the URL manually.
 */
const router = new VueRouter({
  // mode: 'abstract',
  routes,
});

export default router;
